import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import FontAwesome from 'react-fontawesome';

import Api from '../../Api';
import Image from '../../components/Image';
import Processing from '../../components/Processing';

let currentPromise = null;
let currentlyLoading = null;

export default class BrandBar extends React.Component {
  static propTypes = {
    brandToken: PropTypes.string,
    retailerToken: PropTypes.string.isRequired,
    urlPrefix: PropTypes.string,
    currentProductToken: PropTypes.string
  };

  static contextTypes = {
    router: PropTypes.object
  };

  constructor(props) {
    super(props);

    this.loadBrand = this.loadBrand.bind(this);
    this.onBrandBarClick = this.onBrandBarClick.bind(this);

    this.state = {
      brandToken: this.props.brandToken,
      brand: null,
      recommendations: null,
      loading: false,
      error: null
    };
  }

  componentWillMount() {
    this.loadBrand();
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.brandToken !== nextProps.brandToken) this.setState({ brandToken: nextProps.brandToken });
  }

  componentDidUpdate(oldProps, oldState) {
    if (oldState.brandToken !== this.state.brandToken) this.loadBrand();
  }

  loadBrand() {
    if (this.state.brandToken === null) {
      if (!this.state.brand) return;

      this.setState({
        brand: null,
        loading: false,
        error: null
      });
      return;
    }

    if (this.state.brand && this.state.brand.token === this.state.brandToken) {
      return;
    }

    this.setState({
      brand: null,
      loading: true,
      error: null
    });

    if (currentPromise && currentlyLoading === this.state.brandToken) return currentPromise;

    currentlyLoading = this.state.brandToken;
    currentPromise = Api.getBrand(this.state.brandToken, true)
      .then(response => {
        this.setState({
          brand: response
        });
        return Api.getBrandProducts(this.state.brandToken, true);
      })
      .then(response => {
        currentPromise = null;
        this.setState({
          recommendations: response,
          loading: false
        });
      })
      .catch(error => {
        currentPromise = null;
        this.setState({
          loading: false,
          error
        });
      });
  }

  onBrandBarClick(event, productToken) {
    event.preventDefault();
    let urlPrefix = this.props.urlPrefix || `/retailer/${this.props.retailerToken}`;
    let url = `${urlPrefix}/product/${productToken}`;

    this.context.router.replace(url);
  }

  render() {
    if (!this.props.brandToken) return null;
    if (this.state.loading) {
      return (
        <div className="brand-bar-component loading"><Processing/></div>
      );
    }

    if (this.state.error) {
      // Do not show any errors to the user, just hide the bar
      console.error(this.state.error);
      return null;
    }

    let productList = this.state.recommendations
      .filter(product => product.token !== this.props.currentProductToken)
      .map(product => <SingleProduct key={`brand-bar-product-${product.token}`} urlPrefix={this.props.urlPrefix} product={product} onClick={this.onBrandBarClick} />);

    if (!productList || productList.length === 0) return null;

    let minimum = null;
    if (this.state.brand) {
      let minimum_cents = this.state.brand.minimum_order_amount_cents;
      minimum = minimum_cents ? `Maker Minimum $${Api.Utils.formatCents(minimum_cents, true)}` : 'No Minimum';
    }

    return (
      <div className="brand-bar-component">
        <div className="header">
          <div className="brand">More from {this.state.brand.name}</div>
          <div className="minimum">{minimum}</div>
        </div>
        <div className="products">{productList}</div>
      </div>
    );
  }
}

const SingleProduct = ({product, onClick}) => {
  let allImages = [];

  if (product.images && product.images.length > 0) {
    product.images.forEach(image => allImages.push(image));
  }

  (product.options || []).forEach(option => {
    (option.images || []).forEach(image => allImages.push(image));
  });

  if (allImages.length === 0) return null;

  let exclamation = product.active ? null : <FontAwesome name="exclamation-circle" />

  return (
    <Link className="product" onClick={(event) => onClick(event, product.token)}>
      {exclamation}
      <Image image={allImages[0]} stretchAndCrop={true} width={108} height={124} />
    </Link>
  );
};



/** WEBPACK FOOTER **
 ** ./src/views/ProductModal/brand_bar.js
 **/